import React, { useState } from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import { submitCheckIn } from '../services/squareApi';

const { FiCamera, FiUpload, FiCheck, FiX } = FiIcons;

function PhotoUpload({ 
  customerData, 
  appointmentData, 
  onNavigate, 
  setIsLoading, 
  setError 
}) {
  const [selectedFile, setSelectedFile] = useState(null);
  const [preview, setPreview] = useState(null);

  const handleFileSelect = (e) => {
    const file = e.target.files[0];
    if (file) {
      setSelectedFile(file);
      const reader = new FileReader();
      reader.onload = (e) => setPreview(e.target.result);
      reader.readAsDataURL(file);
    }
  };

  const handleSubmit = async () => {
    setIsLoading(true);
    setError('');

    try {
      const result = await submitCheckIn(appointmentData.id, selectedFile);
      if (result.success) {
        onNavigate('confirmation');
      } else {
        setError(result.error || 'Failed to submit check-in. Please try again.');
      }
    } catch (err) {
      setError('Something went wrong. Please try again.');
    } finally {
      setIsLoading(false);
    }
  };

  const removePhoto = () => {
    setSelectedFile(null);
    setPreview(null);
  };

  return (
    <div className="space-y-6">
      <motion.div
        initial={{ scale: 0.95 }}
        animate={{ scale: 1 }}
        className="text-center"
      >
        <div className="text-6xl mb-4">📸</div>
        <h2 className="text-2xl font-bold text-slate-800 mb-2">
          Optional: Add a Photo
        </h2>
        <p className="text-slate-600">
          Want to snap a quick photo of your knives for your record?
        </p>
      </motion.div>

      <div className="space-y-4">
        {!preview ? (
          <label className="block">
            <input
              type="file"
              accept="image/*"
              onChange={handleFileSelect}
              className="hidden"
            />
            <div className="border-2 border-dashed border-slate-300 rounded-xl p-8 text-center hover:border-[#0C1C35] hover:bg-slate-50 transition-all cursor-pointer">
              <SafeIcon icon={FiCamera} className="w-12 h-12 text-slate-400 mx-auto mb-3" />
              <p className="text-slate-600 font-medium mb-1">Tap to take a photo</p>
              <p className="text-sm text-slate-500">or select from your device</p>
            </div>
          </label>
        ) : (
          <motion.div
            initial={{ opacity: 0, scale: 0.95 }}
            animate={{ opacity: 1, scale: 1 }}
            className="relative"
          >
            <img
              src={preview}
              alt="Knife preview"
              className="w-full h-48 object-cover rounded-xl"
            />
            <button
              onClick={removePhoto}
              className="absolute top-2 right-2 bg-red-500 text-white p-2 rounded-full hover:bg-red-600 transition-colors"
            >
              <SafeIcon icon={FiX} className="w-4 h-4" />
            </button>
          </motion.div>
        )}
      </div>

      <button
        onClick={handleSubmit}
        className="w-full bg-[#0C1C35] text-white py-4 rounded-xl font-medium hover:bg-blue-900 transition-colors flex items-center justify-center gap-2"
      >
        <SafeIcon icon={FiCheck} className="w-5 h-5" />
        Submit Check-In
      </button>
    </div>
  );
}

export default PhotoUpload;